import React from 'react';

import { Paper } from '@material-ui/core';

function Container({ children }) {
  return (
    <Paper
      elevation={3}
      style={{
        margin: 10,
        padding: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      {children}
    </Paper>
  );
}

export default Container;
